import React from "react";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";

import "./styles.scss";
import { isAdult } from "halifax";
import { LoyaltyInfo, Person } from "redmond";
import dayjs from "dayjs";
import * as textConstants from "./constants";

interface ITravelersSummary {
  travelers?: string;
  className?: string;
  label?: string | JSX.Element;
  guests?: Person[];
  loyaltyInfo?: LoyaltyInfo;
}

export const TravelersSummary = ({
  travelers,
  className,
  label = textConstants.TRAVELERS_TEXT,
  guests,
  loyaltyInfo,
}: ITravelersSummary) => {
  const getTravelersDetails = () => {
    if (travelers)
      return (
        <Typography variant="subtitle2" className="traveler-names">
          {travelers}
        </Typography>
      );

    let adultsCount = 0;
    const childrenAges: number[] = [];
    guests?.forEach((guest) => {
      if (isAdult(guest.dateOfBirth)) {
        adultsCount += 1;
      } else {
        const age = dayjs().diff(
          dayjs(guest.dateOfBirth, "YYYY-MM-DD"),
          "year"
        );

        childrenAges.push(age);
      }
    });

    if (adultsCount) {
      const adultsCountComponent = (
        <Typography variant="body2" className="adults-count">
          {adultsCount} adult{(adultsCount ?? 0) > 1 ? "s" : ""}
        </Typography>
      );

      if ((childrenAges?.length ?? 0) > 1) {
        const childrenAgeString = childrenAges?.reduce(
          (acc, curr, index) =>
            `${acc}${curr}${
              index !== (childrenAges?.length ?? 0) - 1 ? ", " : ""
            }`,
          ""
        );
        return (
          <>
            {adultsCountComponent}
            <Typography variant="body2" className="children-ages">
              {childrenAges.length}{" "}
              {(childrenAges?.length ?? 0) > 1 ? "children" : "child"} (age
              {(childrenAges?.length ?? 0) > 1 ? "s " : " "}
              {childrenAgeString})
            </Typography>
          </>
        );
      }
      return adultsCountComponent;
    }
    return undefined;
  };

  return (
    <Box className={clsx("travelers-summary-container", className)}>
      <Typography variant="body2" className="travelers-text">
        {label}
      </Typography>
      {getTravelersDetails()}
      {loyaltyInfo && (
        <Typography variant="subtitle2" className="loyalty-number">
          {`${loyaltyInfo.programName}: ${loyaltyInfo.membershipNumber}`}
        </Typography>
      )}
    </Box>
  );
};
